<template>
  <div class="rule-container">
    <!-- 固定在页面上方的更新按钮 -->

    <div class="left content-left">
      <shareParkingTree
        v-on:handleTreeClick="handleTreeClick"
        shareType="share"
        moduleName="parking"
      ></shareParkingTree>
    </div>

    <div class="right content-right list">
      <div class="rule-header" v-if="search.parkingId">
        <div class="header-left">
          <h3 class="form-title">预约规则配置</h3>
          <p class="form-subtitle">配置停车场预约相关的时间规则和计费标准</p>
        </div>
        <div class="header-right">
          <el-button type="primary" class="update-btn" @click="onUpdate">
            <i class="el-icon-check"></i>
            保存
          </el-button>
        </div>
      </div>

      <div class="content-wrapper">
        <!-- 可滚动的配置内容 -->
        <div class="scrollable-content">
          <el-form
            v-if="search.parkingId"
            :model="formData"
            :label-width="formLabelWidth"
            class="form-appointment-rule"
          >
            <!-- 基础规则配置 -->
            <div class="config-group">
              <h3 class="group-title">
                <i class="el-icon-setting"></i>
                基础规则配置
              </h3>
              
              <div class="form-section">
                <h4 class="section-title">
                  <i class="el-icon-close"></i>
                  取消规则
                </h4>
                <el-row class="form-row">
                  <el-col :span="3"><div class="label">预约后</div></el-col>
                  <el-col :span="2">
                    <div class="input">
                      <el-input
                        v-model="formData.cancelTime"
                        placeholder="请输入分钟数"
                      ></el-input>
                    </div>
                  </el-col>
                  <el-col :span="16">
                    <div class="desc">分钟内可免费取消</div>
                  </el-col>
                </el-row>
              </div>
            </div>

            <!-- 计费规则配置 -->
            <div class="config-group billing-rules-group">
              <h3 class="group-title">
                <i class="el-icon-money"></i>
                计费规则配置
              </h3>
              
              <div class="form-section">
                <h4 class="section-title">
                  <i class="el-icon-time"></i>
                  超时计费
                </h4>
                <el-row class="form-row">
                  <el-col :span="5">
                    <div class="label">超出车位分享时间，</div>
                  </el-col>
                  <el-col :span="6">
                    <div class="desc">超出部分时间按现有预约计费规则 </div>
                  </el-col>
                  <el-col :span="2">
                    <div class="input">
                      <el-input
                        v-model="formData.overTimeRate"
                        placeholder="倍数"
                      ></el-input>
                    </div>
                  </el-col>
                  <el-col :span="2">
                    <div class="desc label">倍计费</div>
                  </el-col>
                </el-row>
              </div>

              <div class="form-section">
                <h4 class="section-title">
                  <i class="el-icon-moon"></i>
                  夜间规则
                </h4>
                <el-row class="form-row">
                  <el-col :span="3">
                    <div class="label">夜间时间</div>
                  </el-col>
                  <el-col :span="2">
                    <div class="input">
                      <el-input
                        v-model="formData.nightTime"
                        placeholder="如：22:00"
                      ></el-input>
                    </div>
                  </el-col>
                  <el-col :span="3">
                    <div class="desc">后，一次性收取</div>
                  </el-col>
                  <el-col :span="2">
                    <div class="input">
                      <el-input
                        v-model="formData.nightRate"
                        placeholder="小时"
                      ></el-input>
                    </div>
                  </el-col>
                   <el-col :span="7">
                    <div class="desc label">小时超时停车费，分享时间内不计入超时</div>
                  </el-col>
                </el-row>
               
              </div>
            </div>

            <!-- 提醒规则配置 -->
            <div class="config-group reminder-rules-group">
              <h3 class="group-title">
                <i class="el-icon-bell"></i>
                提醒规则配置
              </h3>
              
              <div class="form-section">
                <h4 class="section-title">
                  <i class="el-icon-right"></i>
                  进场提醒
                </h4>
                <el-row class="form-row">
                  <el-col :span="4">
                    <div class="label">预约进场时间前</div>
                  </el-col>
                  <el-col :span="2">
                    <div class="input">
                      <el-input
                        v-model="formData.arrivalRemindTime"
                        placeholder="请输入分钟数"
                      ></el-input>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="inline-reminder-block">
                      <span class="desc-text">分钟车辆未到达预定车位，系统推送提醒消息</span>
                     
                      <div class="notification-options-inline">
                         <span class="notification-label">通知方式：</span>
                        <el-checkbox v-model="formData.arrivalRemindWechat" class="notification-option">
                          <i class="el-icon-message"></i> 微信
                        </el-checkbox>
                        <el-checkbox v-model="formData.arrivalRemindSms" class="notification-option">
                          <i class="el-icon-phone"></i> 短信
                        </el-checkbox>
                      </div>
                    </div>
                  </el-col>
                </el-row>

                <el-row class="form-row">
                  <el-col :span="4">
                    <div class="label">预约进场时间前</div>
                  </el-col>
                  <el-col :span="2">
                    <div class="input">
                      <el-input
                        v-model="formData.changeSpaceTime"
                        placeholder="请输入分钟数"
                      ></el-input>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="inline-reminder-block">
                      <span class="desc-text">分钟如果预约车位被占，系统推送更换车位提醒消息</span>
                     
                      <div class="notification-options-inline">
                         <span class="notification-label">通知方式：</span>
                        <el-checkbox v-model="formData.changeSpaceWechat" class="notification-option">
                          <i class="el-icon-message"></i> 微信
                        </el-checkbox>
                        <el-checkbox v-model="formData.changeSpaceSms" class="notification-option">
                          <i class="el-icon-phone"></i> 短信
                        </el-checkbox>
                      </div>
                    </div>
                  </el-col>
                </el-row>

                <el-row class="form-row">
                  <el-col :span="4">
                    <div class="label">入场后</div>
                  </el-col>
                  <el-col :span="2">
                    <div class="input">
                      <el-input
                        v-model="formData.arrivalAfterTime"
                        placeholder="请输入分钟数"
                      ></el-input>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="inline-reminder-block">
                      <span class="desc-text">分钟内未达指定车位，系统推送提醒消息</span>
                   
                      <div class="notification-options-inline">
                           <span class="notification-label">通知方式：</span>
                        <el-checkbox v-model="formData.arrivalAfterWechat" class="notification-option">
                          <i class="el-icon-message"></i> 微信
                        </el-checkbox>
                        <el-checkbox v-model="formData.arrivalAfterSms" class="notification-option">
                          <i class="el-icon-phone"></i> 短信
                        </el-checkbox>
                      </div>
                    </div>
                  </el-col>
                </el-row>

                <div class="reminder-options">
                  <div class="reminder-item">
                    <div class="reminder-content">
                      <div class="reminder-main">
                        <el-checkbox v-model="formData.billingReminder">计费开始，系统推送提醒消息</el-checkbox>
                      </div>
                      <div class="notification-section" v-if="formData.billingReminder">
                        
                        <div class="notification-options-group">
                          <span class="notification-label">通知方式：</span>
                          <el-checkbox v-model="formData.billingRemindWechat" class="notification-option">
                            <i class="el-icon-message"></i> 微信
                          </el-checkbox>
                          <el-checkbox v-model="formData.billingRemindSms" class="notification-option">
                            <i class="el-icon-phone"></i> 短信
                          </el-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="reminder-item">
                    <div class="reminder-content">
                      <div class="reminder-main">
                        <el-checkbox v-model="formData.overtimeReminder">超过预约时间段继续停车，系统推送提醒消息</el-checkbox>
                      </div>
                      <div class="notification-section" v-if="formData.overtimeReminder">
                       
                        <div class="notification-options-group">
                           <span class="notification-label">通知方式：</span>
                          <el-checkbox v-model="formData.overtimeRemindWechat" class="notification-option">
                            <i class="el-icon-message"></i> 微信
                          </el-checkbox>
                          <el-checkbox v-model="formData.overtimeRemindSms" class="notification-option">
                            <i class="el-icon-phone"></i> 短信
                          </el-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-section">
                <h4 class="section-title">
                  <i class="el-icon-back"></i>
                  出场提醒
                </h4>
                <el-row class="form-row">
                  <el-col :span="6">
                    <div class="label">车位分享时间结束前</div>
                  </el-col>
                  <el-col :span="2">
                    <div class="input">
                      <el-input
                        v-model="formData.exitRemindTime"
                        placeholder="请输入分钟数"
                      ></el-input>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="inline-reminder-block">
                      <span class="desc-text">分钟，系统推送提醒消息</span>
                
                      <div class="notification-options-inline">
                              <span class="notification-label">通知方式：</span>
                        <el-checkbox v-model="formData.exitRemindWechat" class="notification-option">
                          <i class="el-icon-message"></i> 微信
                        </el-checkbox>
                        <el-checkbox v-model="formData.exitRemindSms" class="notification-option">
                          <i class="el-icon-phone"></i> 短信
                        </el-checkbox>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>

              <div class="form-section">
                <h4 class="section-title">
                  <i class="el-icon-moon"></i>
                  夜间提醒
                </h4>
                <el-row class="form-row">
                  <el-col :span="6">
                    <div class="label">夜间超时</div>
                  </el-col>
                  <el-col :span="2">
                    <div class="input">
                      <el-input
                        v-model="formData.nightRemindTime"
                        placeholder="请输入分钟数"
                      ></el-input>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="inline-reminder-block">
                      <span class="desc-text">分钟前，系统推送提醒消息</span>
                     
                      <div class="notification-options-inline">
                         <span class="notification-label">通知方式：</span>
                        <el-checkbox v-model="formData.nightRemindWechat" class="notification-option">
                          <i class="el-icon-message"></i> 微信
                        </el-checkbox>
                        <el-checkbox v-model="formData.nightRemindSms" class="notification-option">
                          <i class="el-icon-phone"></i> 短信
                        </el-checkbox>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>



            <!-- 补充说明 -->
            <div class="config-group">
              <h3 class="group-title">补充说明</h3>
              <div class="form-section">
                <div class="other-desc">
                  <ul class="rule-list">
                    <li>车辆提前进场，按预约计费规则计费</li>
                    <li>超预约进场时间进场，自预约进场时间计费</li>
                    <li>预约未进场，自预约进场时间至预约出场时间或用户主动取消时间段计费</li>
                    <li>夜间停车，车位处于分享上架出租状态，不计入超时</li>
                  </ul>
                </div>
              </div>
            </div>
          </el-form>
          <el-empty v-else description="请先选择左侧的停车场" :image-size="120">
            <!-- <el-button type="primary" size="small">选择停车场</el-button> -->
          </el-empty>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import dayjs from "dayjs";
import {
  shareChargeRuleList,
  delShareSpaceChargeRule,
  shareParks,
  areasByShareParkingId,
  testChargeRule,
} from "@/api/url";

import shareParkingTree from "../commons/parking/commons/share-parking-tree.vue";

export default {
  data() {
    return {
      tableLoading: false,
      testLoading: false,
      parks: [],
      areas: [],
      dialogFormVisible: false,
      formLabelWidth: "120px",
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      search: {
        pageNumber: 1,
        pageSize: 10,
        parkingId: "",
        areaId: "",
      },

      tableListData: {
        rows: [],
      },

      formLabelWidth: "100px",
      testResult: "",
      testForm: {
        time: [],
      },
      currentRule: {},

      // 新增表单数据
      formData: {
        cancelTime: "",
        arrivalRemindTime: "",
        arrivalRemindWechat: false,
        arrivalRemindSms: false,
        changeSpaceTime: "",
        changeSpaceWechat: false,
        changeSpaceSms: false,
        arrivalAfterTime: "",
        arrivalAfterWechat: false,
        arrivalAfterSms: false,
        billingReminder: false,
        billingRemindWechat: false,
        billingRemindSms: false,
        overtimeReminder: false,
        overtimeRemindWechat: true,
        overtimeRemindSms: false,
        exitRemindTime: "",
        exitRemindWechat: false,
        exitRemindSms: false,
        overTimeRate: "",
        nightTime: "",
        nightRate: "",
        nightRemindTime: "",
        nightRemindWechat: false,
        nightRemindSms: false,
      },
    };
  },

  methods: {
    getShareParks() {
      this.$postRequest(shareParks(), {}).then((res) => {
        if (res.status == 200) {
          this.parks = res.data.data.rows ?? [];
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onParkChange(id) {
      this.search.areaId = "";
      this.$get(`${areasByShareParkingId()}/${id}`, {}).then((res) => {
        if (res.status == 200) {
          this.areas = res.data ?? [];
        } else {
          this.$message.error(res.message);
        }
      });
    },

    handleTreeClick: function (node) {
      // 如果节点类型为停车场
      if (node.type === "parking") {
        this.search.parkingId = node.id;
        this.onParkChange(node.id);
        // 获取预约规则配置数据
        this.getAppointmentRuleConfig(node.id);
      } else {
        this.search.parkingId = undefined;
        // 清空表单数据
        this.clearFormData();
      }
    },

    // 获取预约规则配置
    getAppointmentRuleConfig(parkingId) {
      // 这里应该调用API获取预约规则配置
      // 暂时使用模拟数据
      this.$message.info(`正在获取停车场 ${parkingId} 的预约规则配置...`);

      // 模拟API调用
      setTimeout(() => {
        // 模拟数据，实际应该从API获取
        this.formData = {
          cancelTime: "15",
          arrivalRemindTime: "5",
          arrivalRemindWechat: true,
          arrivalRemindSms: false,
          changeSpaceTime: "10",
          changeSpaceWechat: true,
          changeSpaceSms: true,
          arrivalAfterTime: "15",
          arrivalAfterWechat: true,
          arrivalAfterSms: false,
          billingReminder: true,
          billingRemindWechat: true,
          billingRemindSms: false,
          overtimeReminder: true,
          overtimeRemindWechat: true,
          overtimeRemindSms: false,
          exitRemindTime: "30",
          exitRemindWechat: true,
          exitRemindSms: true,
          overTimeRate: "2",
          nightTime: "23:00",
          nightRate: "6",
          nightRemindTime: "30",
          nightRemindWechat: true,
          nightRemindSms: true,
        };
        this.$message.success("预约规则配置加载完成");
      }, 500);
    },

    // 清空表单数据
    clearFormData() {
      this.formData = {
        cancelTime: "",
        arrivalRemindTime: "",
        arrivalRemindWechat: false,
        arrivalRemindSms: false,
        changeSpaceTime: "",
        changeSpaceWechat: false,
        changeSpaceSms: false,
        arrivalAfterTime: "",
        arrivalAfterWechat: false,
        arrivalAfterSms: false,
        billingReminder: false,
        billingRemindWechat: false,
        billingRemindSms: false,
        overtimeReminder: false,
        overtimeRemindWechat: false,
        overtimeRemindSms: false,
        exitRemindTime: "",
        exitRemindWechat: false,
        exitRemindSms: false,
        overTimeRate: "",
        nightTime: "",
        nightRate: "",
        nightRemindTime: "",
        nightRemindWechat: true,
        nightRemindSms: true,
      };
    },

    onUpdate() {
      if (!this.search.parkingId) {
        this.$message.warning("请先选择停车场");
        return;
      }

      // 这里应该调用API保存预约规则配置
      this.$message.success("预约规则配置更新成功！");
      console.log("更新的配置数据：", this.formData);
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  components: {
    shareParkingTree,
  },

  created: function () {},
  mounted: function () {
    this.search.pageNumber = 1;
    console.log("组件已挂载，初始状态：", {
      search: this.search,
      formData: this.formData,
    });
    // this.tableList(1);
    // this.getShareParks();
  },
};
</script>
<style scoped>
.rule-container {
  position: relative;
  background: transparent !important;
  height: 100vh;
  display: flex;
  overflow: hidden; /* 防止页面整体滚动 */
}
.rule-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  background-color: #ffffff;
  z-index: 100;
  padding: 20px 24px;
  box-sizing: border-box;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid #e4e7ed;
  margin-bottom: 10px;
}

.header-left {
  flex: 1;
}

.header-right {
  flex-shrink: 0;
}

.content-wrapper {
  position: relative;
  height: calc(100% - 100px); /* 减去头部高度 */
  overflow: hidden; /* 内容包装器本身不滚动 */
  box-sizing: border-box;
}

.scrollable-content {
  height: 100%;
  overflow-y: auto; /* 内容区域可滚动 */
  box-sizing: border-box;
  padding: 0 20px 20px 20px;
}

.form-appointment-rule {
  position: relative;
  background: #ffffff;
  border-radius: 8px;
  padding: 24px 32px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  min-width: 900px;
  max-width: 1200px;
  margin: 0 auto;
  font-size: 16px;
  border: 1px solid #e4e7ed;
}

.form-header {
  margin-bottom: 24px;
  text-align: center;
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
}

.form-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 8px 0;
}

.form-subtitle {
  font-size: 14px;
  color: #909399;
  margin: 0;
}

.config-group {
  margin-bottom: 32px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
  overflow: hidden;
}

.group-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin: 0;
  padding: 16px 20px;
  background: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  gap: 8px;
}

.group-title i {
  font-size: 18px;
  color: #409eff;
}

.billing-rules-group .group-title {
  background: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
  color: #303133;
}

.billing-rules-group .group-title i {
  color: #409eff;
}

.form-section {
  margin: 0;
  padding: 20px;
  border-bottom: 1px solid #f0f2f5;
}

.form-section:last-child {
  border-bottom: none;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-right: 20px;
}

.section-title::before {
  content: "";
  width: 3px;
  height: 16px;
  background: #409eff;
  margin-right: 8px;
  border-radius: 2px;
}

.section-title i {
  font-size: 16px;
  color: #409eff;
}

.billing-rules-group .section-title i {
  color: #409eff;
}

.billing-rules-group .section-title::before {
  background: #409eff;
}

.billing-rules-group {
  border: 1px solid #e4e7ed;
  box-shadow: none;
}

.billing-rules-group .form-section {
  background: transparent;
  border-bottom: 1px solid #f0f2f5;
}

.billing-rules-group .form-section:last-child {
  border-bottom: none;
}

.billing-rules-group .form-row {
  background: transparent;
  padding: 0;
  border-radius: 0;
  margin-bottom: 16px;
  border: none;
  transition: none;
}

.billing-rules-group .form-row:hover {
  border-color: transparent;
  box-shadow: none;
}

.reminder-rules-group .group-title {
  background: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
  color: #303133;
}

.reminder-rules-group .group-title i {
  color: #409eff;
}

.reminder-rules-group {
  border: 1px solid #e4e7ed;
  box-shadow: none;
}

.reminder-rules-group .form-section {
  background: transparent;
  border-bottom: 1px solid #f0f2f5;
}

.reminder-rules-group .form-section:last-child {
  border-bottom: none;
}

.reminder-rules-group .form-row {
  background: transparent;
  padding: 0;
  border-radius: 0;
  margin-bottom: 16px;
  border: none;
  transition: none;
  box-shadow: none;
}

.reminder-rules-group .form-row:hover {
  border-color: transparent;
  box-shadow: none;
  transform: none;
}

.reminder-rules-group .section-title {
  color: #303133;
  font-weight: 600;
  margin-bottom: 16px;
  padding-bottom: 0;
  border-bottom: none;
}

.reminder-rules-group .section-title::before {
  background: #409eff;
  width: 3px;
  height: 16px;
}

.reminder-rules-group .section-title i {
  color: #409eff;
  font-size: 16px;
}



.form-row {
  margin-bottom: 16px;
  align-items: center;
  justify-content: flex-start;
}

.form-row:last-child {
  margin-bottom: 0;
}

.form-appointment-rule .el-col {
  display: flex;
  align-items: center;
}

.label {
  color: #303133;
  font-weight: 500;
  text-align: right;
  flex: 1;
  padding-right: 12px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.input {
  flex: 2;
}

.desc {
  flex: 3;
  color: #606266;
  font-size: 13px;
  padding-left: 6px;
  white-space: normal;
  line-height: 1.5;
}

.rate-highlight {
  color: #409eff;
  font-weight: 600;
  background: #f0f9ff;
  padding: 2px 6px;
  border-radius: 3px;
  border: 1px solid #b3d8ff;
}

.desc-full {
  color: #606266;
  font-size: 13px;
  padding-left: 12px;
  line-height: 1.5;
}

.form-appointment-rule .el-input {
  width: 100%;
}

.form-appointment-rule .el-input__inner {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  transition: all 0.2s ease;
}

.form-appointment-rule .el-input__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

.other-desc {
  padding: 0;
  color: #606266;
  font-size: 13px;
  padding-right: 20px;
}

.rule-list {
  margin: 0;
  padding-left: 20px;
  list-style: none;
}

.rule-list li {
  line-height: 1.6;
  margin-bottom: 8px;
  position: relative;
  padding-left: 16px;
}

.rule-list li::before {
  content: "•";
  color: #409eff;
  font-weight: bold;
  position: absolute;
  left: 0;
  top: 0;
}

.rule-list li:last-child {
  margin-bottom: 0;
}

.reminder-options {
  margin-top: 16px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  padding-right: 20px;
}

.reminder-item {
  margin-bottom: 12px;
}

.reminder-item:last-child {
  margin-bottom: 0;
}

.reminder-item .el-checkbox {
  font-size: 14px;
  color: #606266;
}

.inline-reminder-block {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-right: 20px;
}

.desc-text {
  color: #606266;
  font-size: 13px;
  line-height: 1.5;
  flex: 1;
  min-width: 200px;
}

.notification-label {
  color: #409eff;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  margin-left: 8px;
}

.notification-options-inline {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-left: 8px;
  justify-content: flex-start;
}

.notification-option {
  font-size: 12px;
  color: #606266;
  margin: 0;
  transition: all 0.2s ease;
}

.notification-option:hover {
  color: #409eff;
}

.notification-option .el-checkbox__label {
  font-size: 12px;
  padding-left: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.notification-option i {
  font-size: 14px;
}

.reminder-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.reminder-main {
  margin-bottom: 4px;
}

.notification-section {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 24px;
  padding: 8px 12px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  border-left: 3px solid #409eff;
  justify-content: flex-start;
  padding-right: 20px;
}

.notification-section .notification-label {
  font-size: 12px;
  color: #409eff;
  font-weight: 500;
  white-space: nowrap;
}

.notification-section .notification-options-group {
  border-left: none;
  margin-left: 0;
  padding-left: 0;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .form-appointment-rule {
    min-width: 800px;
    padding: 20px 24px;
  }

  .rule-header {
    padding: 16px 20px;
  }

  .scrollable-content {
    padding: 0 16px 16px 16px;
  }
}

@media (max-width: 768px) {
  .rule-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px 20px;
    gap: 16px;
  }

  .header-right {
    align-self: flex-end;
  }

  .scrollable-content {
    padding: 0 16px 16px 16px;
  }

  .form-appointment-rule {
    min-width: auto;
    padding: 16px 20px;
    margin: 0 16px;
  }

  .config-group {
    margin-bottom: 24px;
  }

  .group-title {
    font-size: 15px;
    padding: 12px 16px;
  }

  .form-section {
    padding: 16px;
  }

  .section-title {
    font-size: 15px;
  }

  .label {
    font-size: 13px;
  }

  .desc {
    font-size: 12px;
  }

  .form-title {
    font-size: 18px;
  }

  .form-subtitle {
    font-size: 13px;
  }

  .reminder-options {
    padding: 12px;
  }

  .reminder-block {
    padding: 10px;
  }

  .notification-options-group {
    gap: 12px;
    flex-wrap: wrap;
  }

  .notification-option {
    font-size: 11px;
  }

  .notification-option .el-checkbox__label {
    font-size: 11px;
  }

  .notification-section {
    margin-left: 20px;
    padding: 6px 10px;
  }

  .notification-label {
    font-size: 11px;
  }

  .reminder-rules-group .form-row {
    padding: 0;
    margin-bottom: 12px;
  }

  .reminder-rules-group .section-title {
    font-size: 15px;
    margin-bottom: 12px;
  }

  .reminder-rules-group .section-title i {
    font-size: 15px;
  }

  .inline-reminder-block {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .desc-text {
    min-width: auto;
    font-size: 12px;
  }

  .notification-options-inline {
    margin-left: 0;
    gap: 10px;
  }

  .notification-label {
    margin-left: 0;
    font-size: 11px;
  }
}

.left.content-left {
  flex-shrink: 0; /* 防止左侧收缩 */
  overflow: hidden; /* 移除左侧滚动条 */
  background: transparent !important;
}

/* 覆盖左侧树形菜单的滚动条 */
.left.content-left .el-tree {
  overflow: hidden !important;
}

.left.content-left .trees {
  overflow: hidden !important;
}

.right.content-right {
  flex: 1;
  height: 100%;
  padding-bottom: 20px;
  box-sizing: border-box;
  overflow: hidden !important; /* 防止右侧容器产生滚动条 */
  position: relative;
}

.update-btn {
  font-size: 14px;
  padding: 8px 16px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.update-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
</style>